<script>
import Button from '../../../../components/common/Button'
// import Dropdown from './Dropdown'
import ViewChange from '../../../../components/common/ViewChange'
export default {
  props: {
    title: {
      type: String,
    },
    text: {
      default: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفادهاز طراحان گرافیک است.',
      type: String,
    },
    titleVisible: {
      type: Boolean,
      default: false,
    },
    textVisible: {
      type: Boolean,
      default: false,
    },
    bottomTitle: {
      type: Boolean,
      default: false,
    },
    contextVisible: {
      type: Boolean,
      default: false,
    },
    searchVisible: {
      default: false,
      type: Boolean,
    },
    changeGrid: {
      default: false,
      type: Boolean,
    },
    button: {
      default: false,
      type: Boolean,
    },
    buttonTitle: {
      default: 'مشتری جدید',
      type: String,
    },
    buttonRoute: {
      type: String,
    },
    buttonFunction: {
      type: Function,
      default: null,
    },
    contextClass: {
      type: String,
      default: '',
    },
    actionClass: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
    },
    url: {
      type: String,
    },
    notDropdown: {
      type: Boolean,
      default: false,
    },
    filterList: {
      type: Array,
    },
    tableId: {
      type: Number,
    },
  },
  components: {
    Button,
    ViewChange,
    // Dropdown,
  },
  data() {
    return {
      searchedValue: '',
      showModal: false,
      checkedField: null,
      filters: [],
      // headerFields: [],
      searchQuery: '',
      timer: null,
    }
  },
  methods: {
    // getTeamTaskDataForTable() {
    //   this.$store.dispatch('urlQueries/setCurrentPage', 1)
    //   setTimeout(() => {
    //     const route = this.$route
    //     const teamTaskType = route.params.slug
    //     const query = this.tableData
    //     const pageNumber = this.currentPage
    //     const pageSize = pageSize
    //     let filters = this.fields
    //     let queryParams = {
    //       key: teamTaskType,
    //       query: query,
    //       filters: filters,
    //       pageNumber: pageNumber,
    //       pageSize: pageSize,
    //     }
    //     this.getData(queryParams)
    //     this.changeRoute()
    //   }, 1000)
    // },

    GridView() {
      this.$router.push({ path: '/teamtask-board' })
    },
    doFilter(fieldID, index, field) {
      const textField = this.$refs.textField
      if (this.$route.name === 'userTransactionDetail') {
        console.log(fieldID, index, textField)
        if (textField[index].classList[1] === 'active') textField[index].classList.remove('active')
        else {
          textField.forEach((item, idx) => {
            textField[idx].classList.remove('active')
            if (index === idx) textField[index].classList.toggle('active')
          })
        }

        if (textField[index].classList.contains('active')) {
          this.filters.push(field)
          if (this.filters.length >= 1) this.filters = this.filters.filter((f) => f.label === field.label)
        } else {
          this.filters = this.filters.filter((f) => f.label !== field.label)
        }
      } else {
        textField[index].classList.toggle('active')
        if (textField[index].classList.contains('active')) {
          this.filters.push(fieldID)
        } else {
          let finded = this.filters.find((a) => a == fieldID)
          this.filters = this.filters.filter((a) => a != finded)
        }
      }
      this.tableObj()
      //function e emit konande
    },
    updateSearchQuery() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.tableObj()
      }, 300)
    },
    tableObj() {
      this.$emit('tableObj', { tableId: this.tableId, page: 1, pageSize: 10, filters: this.filters, query: this.searchQuery })
    },
    // searchOnKeyUp($event) {
    //   if ($event) {
    //     setTimeout(() => {
    //       this.getTeamTaskDataForTable()
    //     }, 500)
    //   }
    // },
  },
  computed: {
    routeParam() {
      return this.$route.params.slug
    },
  },
  watch: {
    routeParam(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$router.push({ path: newValue })
      }
    },
  },
  mounted() {},
}
</script>

<template>
  <div class="table-header mb-4">
    <div v-if="contextVisible" class="context mb-4" :class="contextClass">
      <h3 v-if="titleVisible">{{ title }}</h3>
      <h5 v-if="textVisible">{{ text }}</h5>
    </div>

    <div class="actions" :class="actionClass">
      <div v-if="searchVisible" :class="{ actions: $route.name === 'userTransactionDetail' }">
        <div v-if="bottomTitle" class="d-block mb-2">
          <h3>
            {{ title }}
          </h3>
        </div>
        <input placeholder="جستجو" v-model="searchQuery" class="tableSearchInput" @input="updateSearchQuery()" />
        <div v-if="notDropdown && filterList != null" class="sorts">
          <div class="sortList d-flex align-items-center">
            <span>فیلتر سریع: </span>
            <div v-for="(field, index) in filterList" :key="field.key" @click="doFilter(field.key, index, field)">
              <div class="textField" ref="textField" :id="field.key">
                {{ field.label }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-else-if="notDropdown && filterList == null" class="sorts">فیلتر سریع: <Dropdown /></div> -->
        <div v-else-if="notDropdown && filterList == null" class="sorts"></div>
        <div v-else></div>
      </div>
      <div class="button">
        <div v-if="button">
          <div @click="buttonFunction">
            <Button v-if="$route.name !== 'dadbananUserDetail'" hasIcon :text="buttonTitle" />
          </div>
        </div>
        <div v-if="changeGrid">
          <ViewChange :isActive="isActive" :url="url" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.context {
  font-style: normal;
  font-weight: normal;
}
h5 {
  font-size: 15px;
  line-height: 25px;
  color: #999999;
}
h3 {
  font-size: 16px;
  line-height: 26px;
  text-transform: uppercase;
  color: #444444;
  margin: 0;
}
.sorts {
  margin-right: 110px;
}

.actions {
  display: flex;
  align-items: center;
}
.sortList > .textField {
  cursor: pointer;
}
.textField {
  padding: 5px 10px;
  cursor: pointer;
}
.sortList {
  span {
    color: #555555 !important;
  }
  .textField {
    color: #b7b4b4;
  }
}
.textField.active {
  background-color: #556be6;
  color: #fff;
  border-radius: 30px;
  margin-right: 5px;
}
.tableSearchInput {
  border: 1px solid #e8e8e8;
  box-sizing: border-box;
  border-radius: 3px;
  outline: none;
  width: 250px;
  height: 27px;
}
.tableSearchInput::placeholder {
  padding: 0 12px;
}
</style>
